export default __webpack_public_path__ + "static/media/output.d39cc42a.mp3";